import React, {useState, useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import UploadImageContainer from '../../containers/UploadImageContainer';
import CreateTemplateContainer from '../../containers/CreateTemplateContainer';
import ViewTemplates from '../ViewTemplates';
import PrivateRouteContainer from '../../containers/PrivateRouteContainer';
import LogoutIcon from '../../assets/images/logout.svg'
import './style.css'
import Tooltip from '@material-ui/core/Tooltip'
import Modal from 'react-bootstrap/Modal';
import HelperServices from '../../services/CommonServices';
import {
    Switch
} from 'react-router-dom';
import {Constants} from '../../data/Constants';
import LoginLogo from '../../assets/images/skye-innoveo_color-blue.png';
import {logout} from "../../utils/authenticationUtils";

const TIME_OUT_INTERVAL_TIME = 10000;

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: '100%',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: '#ffffff',
        boxShadow: 'none',
        minHeight: '55px',
        height: '70px'
    },
    content: {
        backgroundColor: '#efefef'
    },
    toolbar: theme.mixins.toolbar,
    logoutIcon: {
        width: '28px',
        display: 'inline-block',
        margin: '5px',

    },
    logoutText: {
        fontSize: '15px',
        fontWeight: '400',
        margin: '5px',
        display: 'inline-block',
        color: '#4d4f5c'
    }
}));

function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};

export default function ClippedDrawer(props) {
    let userNameFromToken
    if (localStorage.getItem('token')) {
        try {
            let tokenVal = parseJwt(localStorage.getItem('token'))
            userNameFromToken = tokenVal.sub
        } catch (error) {
            userNameFromToken = ''
        }

    } else {
        userNameFromToken = ''
    }

    useEffect(() => {
        checkOverallHealth();
    }, []);

    function getAlerts() {
        HelperServices.getTokenValidityStatus().then(res => {
            if (res.status === Constants.Failed) {
                const modalInfo = (
                    <div>
                        <span>{Constants.sessionExpiredMessage}</span>
                        <br/>
                        <br/>
                        <div className="right-side">
                            <button className="btn button-global modal-ok" onClick={handleClose}>OK</button>
                        </div>
                    </div>);
                setModalHeading(Constants.headerSessionExpired)
                setModalInfo(modalInfo)
                handleShow()
            }
        })
    }

    function checkOverallHealth() {
        HelperServices.checkOverallHealth().then(response => {
            if (!response) {
                const modalInfo = (
                    <div>
                        <i className="fad fa-exclamation-circle dialog-warning-icon"></i>
                        <h3>{Constants.headerOverallHealth}</h3>
                        <span>{Constants.overallHealthMessage}</span>
                        <br/>
                        <br/>
                        <div className="right-side">
                            <button className="btn button-global modal-ok" onClick={handleClose}>OK</button>
                        </div>
                    </div>)
                setModalInfo(modalInfo);
                handleShow();
            } else {
                getAlerts();
                setInterval(() => getAlerts(), TIME_OUT_INTERVAL_TIME);
            }
        });
    }

    const classes = useStyles();
    const [userName, setUserName] = useState(userNameFromToken);
    const [show, setShow] = useState(false);
    const [modalHeading, setModalHeading] = useState('');
    const [modalInfo, setModalInfo] = useState('');
    const [error, setError] = useState('');

    function handleShow() {
        setShow(true);
    }

    function handleClose() {
        setShow(false);
        window.location.reload();
    }

    return (

        <div className={classes.root}>
            <AppBar position="relative" className={classes.appBar}>
                <Toolbar>
                    <div className="logo">
                        <img src={LoginLogo} alt="Login Logo"/>
                    </div>
                    <div className="logout-div">
                        <div className="vl"></div>
                        <Typography variant="h6" noWrap className={classes.logoutText}>
                            {userName}
                        </Typography>
                        <Tooltip title="logout">
                            <input
                                type="image"
                                id="image"
                                alt="Logout"
                                className={classes.logoutIcon}
                                onClick={() => logout()}
                                src={LogoutIcon}></input>
                        </Tooltip>
                    </div>
                </Toolbar>
            </AppBar>

            <main className={classes.content}>
                <Switch>
                    <PrivateRouteContainer exact path="/upload-image" component={UploadImageContainer}/>
                    <PrivateRouteContainer exact path="/create-template/:id?" component={CreateTemplateContainer}/>
                    <PrivateRouteContainer exact path="/" component={ViewTemplates}/>
                </Switch>
            </main>
            <Modal className="modal-style text-justify" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalHeading}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="table-view">
                    {modalInfo}
                </Modal.Body>
            </Modal>
        </div>
    );
}
